import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/download-qrcode.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-41e6da23")

_pushScopeId("data-v-41e6da23")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createVNode("div", { class: "banner-title" }, [
    /*#__PURE__*/_createVNode("p", { class: "title" }, "湖南广电芒果TV旗下平台"),
    /*#__PURE__*/_createVNode("p", { class: "content" }, "开启芒果生态新潮国货内容电商社交生活新方式")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "video-wrap" }, [
    /*#__PURE__*/_createVNode("video", {
      muted: "",
      autoplay: "",
      loop: "",
      src: "https://ecomvideo1.hitv.com/ecom/v/6/8ce0edbbb7ece76afe831805c8f033c5.mp4"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "download" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("div", { class: "display" }, [
      /*#__PURE__*/_createVNode("div", { class: "mobile" }),
      /*#__PURE__*/_createVNode("div", { class: "mobile-video" }, [
        /*#__PURE__*/_createVNode("video", {
          autoplay: "",
          muted: "",
          loop: "",
          src: "https://ecomvideo3.hitv.com/ecom/v/991/ff84f854ce785694fcec83b145506f45.mp4"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("div", { class: "qrcode" }, [
      /*#__PURE__*/_createVNode("div", { class: "qrcode-logo" }),
      /*#__PURE__*/_createVNode("div", { class: "qrcode-list" }, [
        /*#__PURE__*/_createVNode("div", { class: "qrcode-item" }, [
          /*#__PURE__*/_createVNode("div", { class: "qrcode-box" }, [
            /*#__PURE__*/_createVNode("img", {
              alt: "",
              referrerpolicy: "no-referrer",
              class: "qrcode-img",
              src: _imports_0
            })
          ]),
          /*#__PURE__*/_createVNode("div", { class: "qrcode-download" }, [
            /*#__PURE__*/_createVNode("span", { class: "ios" }, "ios版")
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "qrcode-item" }, [
          /*#__PURE__*/_createVNode("div", { class: "qrcode-box" }, [
            /*#__PURE__*/_createVNode("img", {
              alt: "",
              referrerpolicy: "no-referrer",
              class: "qrcode-img",
              src: _imports_0
            })
          ]),
          /*#__PURE__*/_createVNode("div", { class: "qrcode-download" }, [
            /*#__PURE__*/_createVNode("span", { class: "android" }, "Android版")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = {
  class: "videos-wrap",
  ref: "videos$"
}
const _hoisted_5 = { class: "video" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "video-title" }, [
  /*#__PURE__*/_createVNode("p", null, "好看有态度的国潮视频"),
  /*#__PURE__*/_createVNode("p"),
  /*#__PURE__*/_createVNode("ul", { class: "video-title-list" }, [
    /*#__PURE__*/_createVNode("li", null, "国风视频"),
    /*#__PURE__*/_createVNode("li", null, "汉服视频"),
    /*#__PURE__*/_createVNode("li", null, "好物视频"),
    /*#__PURE__*/_createVNode("li", null, "美食视频"),
    /*#__PURE__*/_createVNode("li", null, "美妆视频"),
    /*#__PURE__*/_createVNode("li", null, "穿搭视频"),
    /*#__PURE__*/_createVNode("li", { class: "more" }, "……")
  ])
], -1)
const _hoisted_7 = { class: "brand" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", { class: "brand-title" }, "发现新潮国货", -1)
const _hoisted_9 = { class: "brand-content" }
const _hoisted_10 = { class: "images" }
const _hoisted_11 = {
  class: "round",
  ref: "round$"
}
const _hoisted_12 = { class: "round-main" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "新潮国货", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_scroll_wrap = _resolveComponent("scroll-wrap")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_scroll_wrap, { ref: "scrollWrap$" }, null, 512)
      ])
    ], 512),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.brandImages, (image, index) => {
            return (_openBlock(), _createBlock("div", {
              key: image,
              class: ['images-item', index === _ctx.activeBrand ? 'active' : ''],
              style: { backgroundImage: `url(${image})` },
              onMouseenter: ($event: any) => (_ctx.toggleActiveBrand(index))
            }, null, 46, ["onMouseenter"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.round, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "round-item",
                key: index,
                style: {
                width: item.size,
                height: item.size,
                top: item.top,
                left: item.left,
                opacity: item.opacity,
                fontSize: item.fontSize,
                paddingLeft: item.padding,
                paddingRight: item.padding,
              }
              }, [
                _createVNode("span", null, _toDisplayString(item.content), 1)
              ], 4))
            }), 128))
          ])
        ], 512)
      ])
    ])
  ]))
})